import { useEffect, useState } from "react";
import { ReportTransport } from "src/app/transports/report";

const useFindWritersBillingPerMonth = () => {
    const [writersBillingPerMonth, setWritersBillingPerMonth] = useState<Array<any>>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        ReportTransport.findWritersBillingPerMonth()
            .then((res) => {
                setWritersBillingPerMonth(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return { writersBillingPerMonth, loading, error };
};

export default useFindWritersBillingPerMonth;
